import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ProductOffering,
  ProductSubscription,
  SelectedProductLineItem,
} from '../entities/db-product-offering.model';
import { DashboardApiService } from './db-api.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardIssuerService extends DashboardApiService {
  // TODO(Fred): All methods below relate to billing checkout and should be moved into it's own service
  loadProductOfferings(): Observable<ProductOffering[]> {
    const url = `/v1/issuer/product_offerings`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  loadProductSubscription(): Observable<ProductSubscription> {
    const url = `/v1/issuer/subscriptions`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  previewProductSubscription(line_items: SelectedProductLineItem[]): Observable<number> {
    const url = `/v1/issuer/subscriptions/preview`;

    return this._post(url, { line_items }).pipe(
      map((res) => this._handleResponse(res, 'due_today')),
      catchError((res) => this._handleError(res)),
    );
  }

  updateProductSubscription(
    line_items: SelectedProductLineItem[],
  ): Observable<ProductSubscription> {
    const url = `/v1/issuer/subscriptions/current`;

    return this._put(url, { line_items }).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  getCheckoutUrl(line_items: SelectedProductLineItem[]): Observable<string> {
    const url = `/v1/issuer/checkout`;

    return this._post(url, { line_items }).pipe(
      map((res) => this._handleResponse(res, 'checkout_url')),
      catchError((res) => this._handleError(res)),
    );
  }
}
